import FeatureContent from "./FeatureContent";
import {React, useEffect, useState } from "react";
import createClient from '../Client';

//feature component wrapper
const Feature = ()  => {
    const[featureData, setFeatureData] = useState([]);

    useEffect(() => {
      createClient.fetch(`*[_type == 'features' && !(_id in path('drafts.**'))] | order(_createdAt desc){
            "id" : _id,
            "iconSrc":featureIcon.asset->url,
            "color":favoriteColor.hex,
            "title": title,
            "content" : content
        }`).then((data) => {
            setFeatureData(data);
        })
      .catch(console.error);
  },[])

    return(
        <section className="features text-center p-top-70">
            <div className="container">
                <FeatureContent featureContent={featureData}></FeatureContent>
            </div>
        </section>
    );
}

export default Feature;